export default {
  survey_answers: {
    Survey_PriceVisit_Very_Correct: 'Very correct',
    Survey_PriceVisit_Correct: 'Correct',
    Survey_PriceVisit_High: 'High',
    Survey_WithWhom_Couple: 'as a couple',
    Survey_WithWhom_Family: 'with family',
    Survey_WithWhom_Friends: 'with friends',
    Survey_WithWhom_Other: 'other',
    Survey_WithWhom_Group: 'in an organized group',
    Survey_WithWhom_Solo: 'alone',
    Survey_FirstVisit_NoCameOnce: "No, I've been here once",
    Survey_FirstVisit_NoCameSeveralTimes: "No, I've been here more than once",
    Survey_WithWhom_FamilyUnder18: 'with family (including children under 18)',
    Survey_WithWhom_FamilyNoUnder18: 'with family (no children under 18)',
    Yes: 'Yes',
    No: 'No',
    Survey_Maybe: 'Maybe',
    Survey_HistoPadUserFriendly_YesIntuitive: "Absolutely, it's intuitive!",
    Survey_HistoPadUserFriendly_YesOk: "Yes, it's fine",
    Survey_Origin_ForeignCountry: 'Foreign country',
    Survey_Origin_France: 'France',
    Survey_Reside_Answer_HautesPyrenees: 'Hautes-Pyrénées',
    Survey_Reside_Answer_HauteGaronne: 'Hautes-Garonne',
    Survey_Reside_Answer_PyreneesAtlantique: 'Pyrénées-Atlantique',
    Survey_Reside_Answer_Gers: 'Gers',
    Survey_Reside_Answer_Other: 'Somewhere else',
    Survey_ResideHautesPyrenees_Answer_Campan: 'The Campan valley (La Mongie, Bagnères de Bigorre)',
    Survey_ResideHautesPyrenees_Answer_Gavarnie: 'The Gavarnie valley (Barèges, Luz, Gavarnie)',
    Survey_ResideHautesPyrenees_Answer_Gaves: 'The Gaves valley (Cauterets, Argelès, Val d’Azun)',
    Survey_ResideHautesPyrenees_Answer_AureLouron: 'The Aure and Luron valley (St Lary, Arreau)',
    Survey_ResideHautesPyrenees_Answer_Lourdes: 'Lourdes',
    Survey_ResideHautesPyrenees_Answer_Other: 'Somewhere else in Hautes-Pyrénées',
    Survey_ResideHauteGaronne_Answer_Luchon: 'Luchon',
    Survey_ResideHauteGaronne_Answer_Other: 'Somewhere else in Haute-Garonne',
    Survey_Income_Answer_LessThan1500: 'less than 1500€',
    Survey_Income_Answer_1500To3000: '1500 to 3000€',
    Survey_Income_Answer_3000To4500: '3000 to 4500€',
    Survey_Income_Answer_4500To6000: '4500 to 6000€',
    Survey_Income_Answer_MoreThan6000: 'more than 6000€',
    Survey_Income_Answer_NoAnswer: "Don't wish to reply",
    Survey_Planetarium_Answer_Yes: 'Yes',
    Survey_Planetarium_Answer_No: 'No',
    Survey_SeanceCoupole_Answer_Yes: 'Yes',
    Survey_SeanceCoupole_Answer_No: 'No',
    Survey_HearAboutSite_WordMouth: 'Word of mouth',
    Survey_HearAboutSite_Report: 'Report (Television/Radio/Newspaper…)',
    Survey_HearAboutSite_Internet: 'Internet',
    Survey_HearAboutSite_Flyer: 'Flyer',
    Survey_HearAboutSite_Advertisment: 'Advertisement (Display/Radio/Voucher…)',
    Survey_HearAboutSite_Other: 'Other',
    Survey_HearAboutExhibit_Television: 'Television',
    Survey_HearAboutExhibit_Radio: 'Radio',
    Survey_HearAboutExhibit_Digital: 'Digital (Mobile/Online)',
    Survey_HearAboutExhibit_WordOfMouth: 'Word of mouth',
    Survey_HearAboutExhibit_Print: 'Print (Newspaper/Magazine)',
    Survey_HearAboutExhibit_Other: 'Other',
    Survey_HearAboutExhibit_Advertisment: 'Advertisement',
    Survey_HearAboutExhibit_Report: 'Report',
    Survey_HearAboutExhibit_Internet: 'Internet',
    Survey_Gender_Male: 'Male',
    Survey_Gender_Female: 'Female',
    Television: 'Television',
    Radio: 'Radio',
    Survey_RentingPrice_JustRight: 'Just right',
    Survey_RentingPrice_TooLow: 'Too low',
    Survey_RentingPrice_TooHigh: 'Too high',
    Others: 'Other answers',
    Survey_VisitPrice_VeryCorrect: 'Very fair',
    Survey_VisitPrice_Correct: 'Fair',
    Survey_VisitPrice_High: 'High',
    Survey_WithWhom_GroupTwentyMore: 'as a group (20 people and more)',
    Survey_Coming_WordMouth: 'Word of mouth',
    Survey_Coming_TravelGuide: 'Travel guide',
    Survey_Coming_CastleWebsite: 'Castle website',
    Survey_Coming_CastleFlyer: 'Castle Brochure',
    Survey_Coming_CastleActivity: 'Activities offered on site',
    Survey_Coming_TouristOffice: 'Tourist Office',
    Survey_Coming_AdvertDisplay: 'Advertising displays',
    Survey_Coming_Media: 'Media (TV, Radio, articles)',
    Survey_Transportation_Car: 'by car',
    Survey_Transportation_Bus: 'by bus',
    Survey_Transportation_NavetteRemi: 'by bus-shuttle château Rémi',
    Survey_Transportation_Bicycle: 'by bicycle',
    Survey_VisitPrice_Correct_Meissen: 'Fair',
    Survey_VisitPrice_High_Meissen: 'High',
    Survey_HearAboutSite_WordMouth_Meissen: 'Word of mouth',
    Survey_HearAboutSite_Internet_Meissen1: 'Website schloesserland-sachsen.de',
    Survey_HearAboutSite_Internet_Meissen2: 'Website albrechtsburg-meissen.de',
    Survey_HearAboutSite_Internet_Moritzburg: 'Website schloss-moritzburg.de',
    Survey_OtherOffers_Event_Moritzburg: 'Events at Moritzburg Palace',
    Survey_OtherOffers_Moritzburg:
      'visiting other tourist attractions in the area, such as the Käthe Kollwitz House or the Little Pheasant Palace',
    Survey_VisitPrice_Low: 'Too low',
    Survey_HearAboutSite_Internet_OtherWebsites: 'Other websites',
    Survey_HearAboutSite_Instagram: 'Instagram',
    Survey_HearAboutSite_Facebook: 'Facebook',
    Survey_HearAboutSite_Magazines: 'Magazines',
    Survey_HearAboutSite_AdvertisementMeissen: 'Posters or advertisements',
    Survey_HearAboutSite_Flyer2: 'Flyers',
    Survey_HearAboutSite_TouristInformationsoffice: 'Tourist information office',
    Survey_HearAboutSite_Hotel: 'Accommodation',
    Survey_HasImprovedVisit_YesGreat: 'Yes, very much!',
    Survey_HasImprovedVisit_YesOk: 'Yes, but not excessively',
    Survey_HearAboutSite_Advertisement: 'Advertisement (Display/Radio/Voucher…)',
    Survey_HearAboutSite_FlyerAdvertisement: 'Leaflet and advertising (poster, flyer)',
    Survey_Age_Category1: 'under 14 years old',
    Survey_Age_Category2: '14-19 years old',
    Survey_Age_Category3: '20-29 years old',
    Survey_Age_Category4: '30-39 years old',
    Survey_Age_Category5: '40-49 years old',
    Survey_Age_Category6: '50-59 years old',
    Survey_Age_Category7: '60-69 years old',
    Survey_Age_Category8: '70+ years old',
    Survey_Age_Category9: '14-18 years old',
    Survey_Age_Category10: '19-30 years old',
    Survey_Age_Category11: '31-45 years old',
    Survey_Age_Category12: '46-60 years old',
    Survey_Age_Category13: '60-70 years old',
    Survey_Age_Category14: '71-80 years old',
    Survey_Age_Category15: '81+ years old',
    Survey_Age_Under18: 'Under 18 years old',
    '18–25': '18-25 years old',
    '26–41': '26–41 years old',
    '42–57': '42–57 years old',
    '58–67': '58–67 years old',
    '68–76': '68–76 years old',
    '77+': '77+ years old',
    PreferNotToAnswer: 'Ich möchte nicht antworten',
    Survey_HasImprovedVisit_NoImprovement: 'No, not at all',
    Survey_WillRecommend_Sure: 'absolutely',
    Survey_WillRecommend_MostlySure: 'probably',
    Survey_WillRecommend_DontKnow: "I don't know",
    Survey_WillRecommend_MaybeNot: 'probably not',
    Survey_WillRecommend_NotAtAll: 'definitely not',
    Survey_OtherOffers_Gastronomy: 'gastronomy',
    Survey_OtherOffers_GuidedTour: 'tours',
    Survey_OtherOffers_Hiking: 'walking/hiking in the area',
    Survey_OtherOffers_RentANightAround: 'spending the night in the area',
    Survey_OtherOffers_Shopping: 'shopping',
    Survey_OtherOffers_Others: 'other',
    Survey_VisitPrice_VeryHappy: 'absolutely!',
    Survey_VisitPrice_Happy: 'yes',
    Survey_VisitPrice_Good: 'I suppose so',
    Survey_VisitPrice_NotMuchHappy: 'Not really',
    Survey_VisitPrice_NotHappyAtAll: 'Not at all',
    HistoricalCharacter: 'Historical character',
    HistoricalMonument: 'Historical monument, world heritage',
    HistoricalEvent: 'Historical event',
    Survey_ContinueOnline_YesNewXP: 'Yes, if there are new experiences',
    Survey_ContinueOnline_YesWithoutXP: 'Yes, even without new experiences',
    Survey_HearAboutSite_Medias: 'Media',
    Survey_HearAboutSite_SocialMedia: 'Social Media',
    Survey_HearAboutSite_Display: 'Poster campaign',
    Survey_HearAboutSite_Press: 'Press',
    Survey_HearAboutSite_ResearchEngine: 'Research engine',
    Survey_WithWhom_SoloSeul: 'alone',
    Survey_DresdenOffers_AudioGuide: 'The Schlösserland audio guide for the Grand Garden',
    Survey_DresdenOffers_ParkRailway: 'Ride through the Grand Garden on the little park train',
    Survey_DresdenOffers_Gastronomie: 'Catering in the Grand Garden of Dresden',
    Survey_DresdenOffers_HygieneMuseum: 'Visit the German Hygiene Museum in Dresden',
    Survey_DresdenOffers_Zoo: 'Visit Dresden Zoo',
    Survey_DresdenOffers_Festung: 'Visit the Festung Xperience',
    Survey_DresdenOffers_Zwinger: 'Visit the Zwinger Xperience',
    Survey_DresdenOffers_Overnight: 'Accommodation in the area',
    'Survey_HearAboutSite_Website_notredame-sachsen': 'Website notredame-dresden.de',
    YesLovedIt: 'Yes, I loved it!',
  },
  survey_questions: {
    Survey_Rating_WelcomeAccessibility: 'Reception and availability of staff',
    Survey_Rating_PracticalInformations: 'Useful informations',
    Survey_Rating_WaitingTime: 'Waiting time',
    Survey_Rating_ComfortCleanliness: 'Comfort and cleanliness',
    Survey_Choice_VisitPrice: 'How do you rate the price of the visit?',
    Survey_HistoPadUserFriendly_Question: 'Is Histopad easy to use?',
    Survey_OpenAnswer_WhatCanWeChange: 'If not, what can we change?',
    Survey_Age_Question: 'How old are you?',
    Survey_Origin_Question: 'Where are you from?',
    Survey_Origin_Pays: 'Where are you from (foreign country)?',
    Survey_Origin_Departement: 'Where are you from (french department)?',
    Survey_Origin_France: 'Where are you from?',
    Survey_FirstVisit_Question: 'Is this your first visit?',
    Survey_FirstVisitHere: 'Is it your first time in this place?',
    Survey_WithWhom_Question: 'You visited...',
    Survey_Rating_Signalitique: 'Signage and information in the site',
    Survey_Rating_CafeChateau: '« Cafe » of the castle',
    Survey_Rating_PropreteMonument: 'Cleanliness and maintenance of the monument',
    Survey_Rating_PropreteSanitaires: 'Clean sanitary facilities',
    Survey_Rating_VisiteChapelle_Chateau: 'Visit of the chapel and the castle',
    Survey_Rating_VisiteJardins: 'Visit of the gardens',
    Survey_Rating_NotesEnfants: 'What did your children think of their visit to the castle?',
    Survey_Reside_Question: 'Où résidez-vous pendant votre séjour ?',
    Survey_ResideHautesPyrenees_Question:
      'Where in Hautes-Pyrénées do you reside during your stay?',
    Survey_ResideHauteGaronne_Question: 'Where in Haute-Garonne do you reside during your stay?',
    Survey_Income_Question: 'What is your net monthly household income? ',
    Survey_Recommend_Question: 'Would you recommend visiting the Pic du Midi?',
    Survey_ExperienceRating_Question_CableCar: 'Cable car trip',
    Survey_ExperienceRating_Question_Panorama: 'The Panorama',
    Survey_ExperienceRating_Question_Ponton: 'The Pontoon in the Sky',
    Survey_ExperienceRating_Question_Animations: 'Animations',
    Survey_ExperienceRating_Question_EspaceExperiences: 'The Experimentation Area',
    Survey_ExperienceRating_Title: 'Did you enjoy your experience at the Pic du Midi?',
    Survey_Planetarium_Question: 'Did you attend a Planetarium session?',
    Survey_PlanetariumRating_Question: 'The Planetarium',
    Survey_PlanetariumRating_Title: 'Did you enjoy this Planetarium session?',
    Survey_SeanceCoupole_Question: 'Did you attend a Cupola session?',
    Survey_SeanceCoupoleRating_Question: 'The Cupola',
    Survey_SeanceCoupoleRating_Title: 'Did you enjoy this Cupola session?',
    Survey_HearAboutSite_Question: 'How did you hear about this museum?',
    Survey_HearAboutSite_Us: 'How did you hear about us?',
    Survey_Origin_ZIPCode: 'What is your ZIP Code?',
    Survey_HearAboutExhibit_Question: 'How did you hear about this exhibit?',
    Survey_HearAboutExhibitInputField_Question: 'Please tell us how you heard about this exhibit',
    Survey_VisitExhibitPrimaryReason_Question:
      'Was seeing this exhibit the primary reason for your visit today?',
    Survey_Gender_Question: 'Are you Male or Female?',
    Survey_GroupSize_Question: 'How many visitors were in your group?',
    Survey_RentingPrice_Question: 'How would you rate the price for renting the HistoPad?',
    Survey_HistopadEaseOfUse_Question: 'Tablet ease of use',
    Survey_HistopadContentQuality_Question: 'Quality of tablet content',
    Survey_HistopadOverallExperience_Question: 'Tablet overall experience',
    Survey_ExhibitNavigation_Question: 'Exhibit ease of navigation',
    Survey_ExhibitPanelContent_Question: 'Quality of panel content',
    Survey_ExhibitOverallExperience_Question: 'Exhibit overall experience',
    Survey_Rating_Boarding: 'Boarding',
    Survey_Rating_Itinerary: 'Suggested itinerary',
    Survey_Rating_AudioContent: 'Audio commentary',
    Survey_Rating_InteractiveXP: 'Interactive experiences',
    Survey_VisitPrice_Question: 'How would you rate the admission price?',
    Survey_FirstVisit_Question_Paris: 'Is this your first trip to Paris?',
    Survey_Rating_Welcome: 'Hospitality',
    Survey_Rating_TipStart: 'Tips for Getting Started',
    Survey_Rating_ComfortVisit: 'Visiting comfort',
    Survey_Rating_Orientation: 'Orientation in the castle',
    Survey_VisitPrice_Question_CastleHistoPad:
      'How would you rate the admission price? (castle + HistoPad)',
    Survey_Decide_Question: 'What will make you decide to come?',
    Survey_Coming_Question: 'Have you come... ',
    Survey_Origin_GermanLand: 'State',
    Survey_VisitPrice_Question_Meissen: 'How would you rate the admission price?',
    Survey_HasImprovedVisit_Question: 'Did the Histopad improve your visit?',
    Survey_WillRecommend: 'Would you recomment a visit to others?',
    Survey_SaySomethingMore: 'Is there anything else you would like to share with us?',
    Survey_Rating_Signage: 'Signage',
    Survey_Bookstore: 'Bookshop - shop (advice and choice)',
    Survey_HearAboutSiteInputField_Question: 'How did you hear about this museum?',
    Survey_RestaurantSaline: '"La table des jardins" restaurant',
    Survey_Age_Question_Categories: 'Which age group do you belong to?',
    Survey_OtherOffers_Question:
      'Which other offers are you taking advantage of? (Multiple answers possible)',
    Survey_Rating_StaffAmability: 'the friendliness of the staff?',
    Survey_Rating_StaffCompetence: 'the competence of the staff?',
    Survey_VisitPrice_QuestionVariant:
      'Do you feel like the cost of admission was worth the visit?',
    Survey_HearAboutSite_UsSeveralChoices: 'How did you hear about us? (Multiple answers possible)',
    Survey_HistoPadUserFriendly_WhatCanWeChange: 'If no, how can we improve it?',
    Survey_OtherSites_Question: 'Would you like to see other sites equipped with a Histopad? ',
    Survey_OtherExhibits_Question:
      'Would you like to see more exhibits like this one in the museum?',
    Survey_ExperienceWas_Ludic: 'How did you find your experience overall? Fun?',
    Survey_ExperienceWas_Pedagogic: 'How did you find your experience overall? Educational? ',
    Survey_ExperienceWas_Immersive: 'How did you find your experience overall? Immersive?',
    Survey_WillRecommend_AugmentedExhibits:
      'Would you recommend this augmented reality exhibition to your friends and family?',
    Survey_OtherAugmentedExhibits_question:
      'Would you like to go to another Augmented Exhibition using a HistoPad?',
    Survey_IfYesWhichSubject: 'If so, on what subject?',
    Survey_WouldYouPay_AugmentedExhibits:
      'Would you be willing to pay for this  Augmented Exhibition?',
    Survey_IfYesHowMuch: 'If so, how much?',
    Survey_ContinueOnline_Question: 'Would you like to extend the experience at home on the web?',
    Survey_HistoPadFirstTime: 'Is this the first time you have used a HistoPad?',
    Survey_HearAboutSite_AugmentedExhibit: 'How did you hear about the  Augmented Exhibition?',
    Survey_OtherAugmentedExhibits_OrPlace_question:
      'Would you like to visit another exhibition or site with HistoPad?',
    Survey_GrossenGarten_Dresden:
      'Is this your first visit to the Palace of the Grand Garden in Dresden?',
    Survey_OtherOffers_Question_long:
      'Which offers have you already used today or will you use again?',
    Survey_Impression_captivating: 'Exciting',
    Survey_Rating_StaffWelcomeAvailability: 'The welcome and availability of the staff',
    Survey_VisitPrice_Ratio: 'Value for money',
    Survey_Rating_SignageInsideCity: 'The interior and urban signage',
    Survey_Bookstore_AdviceChoice: 'Shop (advice and selection)',
    Survey_Rating_VisitContent: 'The tour content',
    Survey_Rating_OpeningHoursMHAB: 'MHAB schedule',
    Survey_HearAboutSite_MHAB: 'How did you hear about the MHAB?',
    Survey_WillRecommend_MHAB: 'Would you recommend visiting the MHAB?',
    Survey_Net_Promoter_Score: 'Net promoter score',
  },
}
